import { PencilIcon } from '@airship-platform/jam-web/icons';
import Button from '@mui/material/Button';
import { Link } from 'react-router';
import { useAppointmentProposals } from '../../../data-access/appointmentProposals';
import ROUTE_PATHS from '../../../routes/paths';

interface ManageOptionsButtonProps {
  disabled?: boolean;
}

const ManageOptionsButton: React.FC<ManageOptionsButtonProps> = ({
  disabled,
}) => {
  const { currentProposal } = useAppointmentProposals();

  if (!currentProposal) {
    return null;
  }

  return (
    <Button
      color="softGold"
      startIcon={<PencilIcon />}
      disabled={disabled}
      component={Link}
      to={ROUTE_PATHS.APPOINTMENT_PATH({
        appointmentId: currentProposal.appointmentId,
        appointmentProposalId: currentProposal.appointmentProposalId,
        path: 'options',
        extraPath: 'manage',
      })}
    >
      Manage options
    </Button>
  );
};

export default ManageOptionsButton;
